import { Button, ButtonProps } from './button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './dialog'
import * as React from 'react'

type DocDeleteDialogProps = {
  title: string
  open?: boolean
  description: React.ReactNode
  handleClose: () => void
  action: () => void
  label?: string
  intent?: ButtonProps['intent']
}

export const DocActionDialog: React.FC<DocDeleteDialogProps> = ({
  title,
  description,
  open,
  handleClose,
  action,
  label = 'Delete',
  intent = 'tertiary',
}) => {
  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter divider>
          <DialogClose asChild className="self-end">
            <Button intent="secondary">Cancel</Button>
          </DialogClose>
          <DialogClose asChild className="self-end">
            <Button intent={intent} onClick={action}>
              {label}
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
